import React, {Component} from "react";
import {SelectList} from "../FormUI";

export default class InsuranceList extends Component {
	render() {
		const {options, ...props} = this.props;

		return (
			<SelectList
				options={opts.map((item) => {
					return {label: item, value: item}
				})}
				simpleValue={true}
				{...props}
			/>
		)
	}
}

const opts = [
	'Green Shield Canada',
	'Sunlife',
	'Manulife',
	'Canada Life',
	'Claim Secure',
	'Dejardins',
	'OTIP / RTIP - Edvantage',
	'Coughlin',
	'Medavie Blue Cross',
	'ODSP',
	'Co-Operators',
	'Industrial Alliance',
	'Equitable Life',
	'Pacific Blue Cross',
	'RWAM',
	'WSIB',
	'Group Medical Services',
	'Empire Life',
	'NIHB',
	'RBC Group Benefits',
	'SSQ Insurance',
	'Ontario Works',
	'Veterans Affairs',
	'Nexgen',
	'BC Pharmacare',
	'Alberta Blue Cross',
	'Alberta Health',
	'Manitoba Health'
].sort();
opts.push('Other')



// WEBPACK FOOTER //
// ./src/components/selectlists/InsuranceList.jsx